import React, { useState } from 'react';
import Nav from "../comps/nav";
import Footer from "../comps/footer";

interface FormData {
    subject: string;
    email: string;
    body: string;
    name: string;
}

function Support() {
    const [formData, setFormData] = useState<FormData>({
        subject: '',
        email: '',
        body: '',
        name: '',
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        // console.log(e.target.name, e.target.value);
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handle_submit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault(); // Prevent default form submission behavior
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/utils/support`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            })

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            else {
                alert('Thank you for the email, we will respond to you within a few business days'); // Notify user
                setFormData({ name: '', subject: '', email: '', body: '' }); // Reset form
            }
        } catch (e) {
        }
    }

    return (
        <main className="min-h-screen bg-[#f2f4f5] pb-20">
            <Nav />
            <section className="relative px-4 pt-12 pb-12">
                <div className="mx-auto max-w-3xl text-gray-800 text-left">
                    <h1 className="text-2xl font-semibold">Support</h1>
                    <p className="text-sm text-gray-500 mt-1">
                        We usually respond within a few business days.
                    </p>

                    <div className="mt-3 rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                        <p className="mb-4 text-gray-800">
                            For any questions or feedback, please fill out the form below.
                        </p>
                        <form onSubmit={handle_submit} className="space-y-4">
                            <div>
                                <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>

                            <div>
                                <label htmlFor="subject" className="block text-sm font-medium text-gray-700">
                                    Subject
                                </label>
                                <input
                                    type="text"
                                    id="subject"
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    required
                                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>

                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                    Your Email
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>

                            <div>
                                <label htmlFor="body" className="block text-sm font-medium text-gray-700">
                                    Questions, Comments, or Concerns
                                </label>
                                <textarea
                                    id="body"
                                    name="body"
                                    value={formData.body}
                                    onChange={handleChange}
                                    required
                                    rows={4}
                                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                ></textarea>
                            </div>

                            <div className="flex justify-end">
                                <button
                                    type="submit"
                                    className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                                >
                                    Send Email
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <Footer />
        </main>
    );
}

export default Support;
